import React, { useEffect, useState } from 'react';
import { LIST_COMPONENT } from '../../../../constants/UiBuilderConst';
import HotelModuleSelector from '../../../../shared/ui-builder/hotel-module-selector/Hotel-Module-Selector';
import ModuleIdSelector from '../../../../shared/ui-builder/module-id-selector/Module-Id-Selector';
import { useSelector } from 'react-redux';
import { allUIBuilderPagesSelector } from '../../../../layouts/property/propertySlice';
import UIBuilderCustomSelect from '../../../../shared/ui-builder/ui-builder-custom-select/UI-Builder-Custom-Select';

const ListComponent = (props) => {
  const { onItemChange, config, handleError, componentNdx } = props;

  const initialState = {
    hotelModuleId: '',
    redirectLink: {
      connection: 'IN_APP',
      linkId: '',
      isActive: true,
    },
  };

  const [hotelModule, setHotelModule] = useState(config?.hotelModule || '');
  const [listItems, setListItems] = useState(
    config?.hotelModule ? config?.listItems : [initialState],
  );
  const [error, setError] = useState(null);
  const [listErrorPos, setListErrorPos] = useState([]);
  const originalPages = useSelector(allUIBuilderPagesSelector);

  useEffect(() => {
    onItemChange({
      componentName: LIST_COMPONENT,
      config: {
        hotelModule: hotelModule,
        listItems: listItems,
      },
    });
  }, [hotelModule, listItems]);

  const setErrorField = (field, val) => {
    if (val) return '';
    return 'required';
  };

  useEffect(() => {
    if (handleError && handleError.length > 0) {
      const currListErrorPos = handleError[0]?.listItems?.map((item) => item.pos);
      setListErrorPos(currListErrorPos);
      const currError = handleError.find(
        (getError) => getError.pos === componentNdx && getError.id === LIST_COMPONENT,
      );
      setError(currError ?? null);
    }
  }, [handleError]);

  const handleTabData = (val, slideContent, field, index) => {
    if (error) {
      const currError = { ...error };
      const currConfigError = { ...currError.config, [field]: setErrorField(field, val) };
      currError.config = currConfigError;
      setError(currError);
    }
    switch (field) {
      case 'hotelModule':
        const templistItems = listItems.map((item) => {
          return { hotelModuleId: '' };
        });
        setListItems(templistItems);
        setHotelModule(val);
        break;
      case 'hotelModuleId':
        const tempListItems = listItems?.map((item, itemIndex) => {
          return {
            ...item,
            hotelModuleId: itemIndex === index ? val : item.hotelModuleId,
          };
        });
        setListItems(tempListItems);
        break;
      case 'linkId':
        const tempLinkListItems = listItems?.map((item, itemIndex) => {
          return {
            ...item,
            linkId: itemIndex === index ? val : item.linkId,
          };
        });
        setListItems(tempLinkListItems);
        break;
      default:
        break;
    }
  };

  const onClickAddItems = (e) => {
    if (listItems.length < 50) {
      const tempListItems = [...listItems];
      tempListItems.push(initialState);
      setListItems(tempListItems);
    }
  };

  const onClickRemove = (index) => {
    if (listItems.length > 1) {
      const tempListItems = [...listItems];
      tempListItems.splice(index, 1);
      setListItems(tempListItems);
    }
  };

  return (
    <div className='row my-2 mx-4'>
      <div className='col-md-12 mb-2'>
        <div className='mb-3'>
          <HotelModuleSelector
            hideNullOption
            hotelModule={hotelModule}
            onChangeHotelModule={(e) => handleTabData(e, listItems, 'hotelModule')}
            error={error?.config?.hotelModule === 'required' ? true : false}
            required={true}
          />
        </div>
        <div className='col-md-12 mb-3'>
          <div className='col-md-12 mb-3 mt-2'>List Items</div>
          {listItems.map((item, itemIndex) => (
            <div className='mb-3' key={itemIndex}>
              <div className='row mb-1 mt-3 d-flex'>
                <div className='col-md-6' style={{ fontSize: '15px' }}>
                  Item {itemIndex + 1}
                </div>
                <div className='col-md-6' align='right' style={{ fontSize: '12px' }}>
                  <span
                    onClick={(e) => onClickRemove(itemIndex)}
                    className='text-underlined pointer'
                  >
                    Remove
                  </span>
                </div>
              </div>
              <div className='col-md-12'>
                <ModuleIdSelector
                  error={
                    hotelModule !== '' &&
                    item?.hotelModuleId === '' &&
                    listErrorPos?.includes(itemIndex)
                  }
                  required={true}
                  disabled={config?.hotelModule ? false : true}
                  hideNullOption
                  hotelModule={hotelModule}
                  hotelModuleId={item.hotelModuleId}
                  onChangeHotelModuleId={(e) =>
                    handleTabData(e.target.value, listItems, 'hotelModuleId', itemIndex)
                  }
                />
              </div>
              <div className='col-md-12 mt-1'>
                <UIBuilderCustomSelect
                  labelField='name'
                  valueField='id'
                  label={'Redirect to In-app page'}
                  options={originalPages}
                  disabled={config?.hotelModule === '' || item.hotelModuleId === ''}
                  value={item.linkId}
                  handleInputChange={(e) =>
                    handleTabData(e.target.value, listItems, 'linkId', itemIndex)
                  }
                />
              </div>
            </div>
          ))}
          <div
            className='mt-1 text-underlined'
            onClick={(e) => onClickAddItems(e)}
            style={{ fontSize: '15px' }}
          >
            + Add New List Item
          </div>
        </div>
      </div>
    </div>
  );
};

export default ListComponent;
